import BasePolicy from '@/policies/BasePolicy.js';

export default class InstitutionSettingPolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view an institution setting';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    view(user, institutionSetting) {
        const permission = 'view an institution setting';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    create(user) {
        const permission = 'create an institution setting';

        return user.hasPermissionTo(permission);
    }

    update(user, institutionSetting) {
        const permission = 'edit an institution setting';

        return user.hasPermissionTo(permission);
    }

    delete(user, institutionSetting) {
        const permission = 'delete an institution setting';

        return user.hasPermissionTo(permission);
    }
}
